import { takeEvery, select, fork, put } from "redux-saga/effects";
import { request } from "util/api/client";
import { confirm, success, error } from "util/saga/feedback";

function* handleRemoveSlugs({ payload, context }) {
    try {
        if (yield confirm("Czy na pewno usunąć niepotrzebne slugi?")) {
            const response = yield request({
                url: `cms/sitemap/remove`,
                method: "post",
                context,
            });
        }
    } catch (e) {}
}

function* handleGenerateSlugs({ payload, context }) {
    try {
        if (yield confirm("Czy na pewno wygenerować brakujące slugi?")) {
            const response = yield request({
                url: `cms/sitemap/generate`,
                method: "post",
                context,
            });
        }
    } catch (e) {}
}

export default function* () {
    yield takeEvery("SITEMAP.SLUGS.REMOVE", handleRemoveSlugs);
    yield takeEvery("SITEMAP.SLUGS.GENERATE", handleGenerateSlugs);
}
